import axios from 'axios';

const API_URL = 'https://huongtramcomoc.vn/api/endpoints/';

// 1. Lấy sản phẩm nổi bật
const getFeaturedProducts = () => {
  return axios.get(API_URL + 'get_featured_products.php'); 
};

// 2. Lấy tất cả sản phẩm 
const getAllProducts = (categoryId) => {
  let url = API_URL + 'get_all_products.php';
  if (categoryId && categoryId !== 'all') {
    url += `?category_id=${categoryId}`;
  }
  
  return axios.get(url);
};

// 3. Lấy chi tiết sản phẩm theo ID
const getProductById = (id) => {
  return axios.get(API_URL + `get_product_by_id.php?id=${id}`);
};

// 4. Lấy sản phẩm bán chạy
const getBestSellers = () => {
  return axios.get(API_URL + 'get_best_sellers.php');
};

// 5. Lấy sản phẩm mới về
const getNewArrivals = () => {
  return axios.get(API_URL + 'get_new_arrivals.php');
};

// 6. Lấy nội dung trang tĩnh (nếu có)
const getPageContent = (slug) => {
  return axios.get(API_URL + `get_page_content.php?slug=${slug}`);
};

const productService = {
  getFeaturedProducts,
  getAllProducts,
  getProductById,
  getBestSellers,
  getNewArrivals,
  getPageContent,
  getProducts: getAllProducts, 
};

export default productService;